import React from 'react';
import { Switch, Route } from 'react-router-dom';

import tax from './tax';


import Error404 from '../Error404';


export default ({ match }) => {
    return (
        <Switch>
            <Route path={`${match.path}/tax`} component={tax} />
            <Route component={Error404} />
        </Switch>
    )
}